import { FINANCEIRO_ES_LIST_LOAD, FINANCEIRO_ES_LIST_UNLOAD, FINANCEIRO_ES_COMPANIES_LOAD } from "../../actions/Constants";

const INITIAL_STATE = { all: null, pagination: null, financeiras: [] };

export default function (state = INITIAL_STATE, action) {
  switch (action.type) {
    case FINANCEIRO_ES_LIST_LOAD:
      return {
        ...state,
        all: action.payload ? action.payload.registros : null,
        pagination: action.payload
          ? {
              totalRegistros: action.payload.totalRegistros,
              numeroPagina: action.payload.numeroPagina,
              tamanhoPagina: action.payload.tamanhoPagina,
              totalPaginas: action.payload.totalPaginas,
              hasPreviousPage: action.payload.hasPreviousPage,
              hasNextPage: action.payload.hasNextPage,
            }
          : null,
      };
    case FINANCEIRO_ES_COMPANIES_LOAD:
      return { ...state, financeiras: action.payload || [] };
    case FINANCEIRO_ES_LIST_UNLOAD:
      return INITIAL_STATE;
    default:
      return state;
  }
}
